<template lang="pug">
.conteudo
    .linha(style='margin: 0px')
        .coluna
            title-component(:label='$route.meta.titulo')
    .container
        CardAnaliseHistorico(v-for="(analise, index) in listAnaliseHistorico" :key="index", :dadosAnalise="analise")

</template>

<script>

import CardAnaliseHistorico from './components/CardAnaliseHistorico.vue';
import {
    analiseHistorico
} from '@/utils/breadcrumb.utils';
import {
    buscarAllAnaliseHistoricoPorIdProcesso,
} from '@/services/processo.service';

export default {
    name: 'AnaiseHistorico',
    components: {
        CardAnaliseHistorico,
    },

    data() {
        return {
            listAnaliseHistorico: [],
            breadcrumbMap: {
                'Historico da Análise': analiseHistorico,
            },
        };
    },

    async created() {
        try {
            const response = await buscarAllAnaliseHistoricoPorIdProcesso(this.id);
            this.listAnaliseHistorico = response?.data || [];
        } catch (error) {
            console.error("Erro ao buscar histórico de analises:", error);
        }
    },

    computed: {
        breadcrumb() {
            const paginaAtual = this.$route.meta.titulo;
            return this.breadcrumbMap[paginaAtual];
        },
        id() {
            return this.$route.params.idProcesso;
        }

    }

};
</script>

<style scoped>
.container {
    max-height: 100vh; /* Define a altura máxima para a altura da viewport */
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 20px;
}
</style>

